export default __webpack_public_path__ + "static/media/boy.6b28c3f7.svg";